import { Box, Typography, Drawer } from '@material-ui/core'
import styled from 'styled-components/macro'
//@ts-ignore
import { useTheme } from 'styled-components'
import AccountSettingsDrawer from './AccountSettingsDrawer'
import { StyledAccountSettingsBox, StyledDrawer, StyledLineDiv } from './styled'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAuth } from 'pages/auth/hooks/useAuth'



export const AccountSettingsSideNav = () => {
  const {isDevice} = useScreenSizes()
  const theme = useTheme()
  const { backendUser} = useAuth()
  return (
    <StyledDrawer variant="permanent" isDevice={isDevice}>
      <Typography variant='h3'>
        <StyledAccountSettingsBox>Account Settings</StyledAccountSettingsBox>
      </Typography>
      <StyledLineDiv/>
      <Box position="relative">
        <AccountSettingsDrawer backendUser={backendUser}/>
      </Box>
    </StyledDrawer>
  )
}
